<p-table #ct [columns]="cabsCols" [value]="cabinetComplexityVariation" [paginator]="true" [rows]="cabsPerPage"
         [totalRecords]="totalElems" [lazy]="true" (onLazyLoad)="loadMaterials($event)"
         (onEditInit)="startEdit($event)">
  <ng-template pTemplate="caption">
    <div class="search-header">
			<span class="p-input-icon-right">
				<i class="pi pi-times cross-icon" (click)="deleteQuery()" *ngIf="searchQuery?.length > 0"></i>
				<input class="global-filter-input" type="text" pInputText BlockLateralArrowNavigation size="50" placeholder="Search in Complexity Types"
               (input)="topSearchBar()" style="width:auto" [(ngModel)]="searchQuery">
			</span>
      <i class="pi pi-search search-icon"></i>
    </div>
    <div class="excel-buttons">
      <button mat-button class="export-button" (click)="downloadXLSX()">
<!--          <mat-icon *ngIf="!loadingSpinner">add</mat-icon>-->
<!--          <lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>-->
          <div class="button-title">Export Data</div>
      </button>
        <p-fileUpload mode="basic" name="files" #filesForm [customUpload]="true" [title]="'Import Data'"
                      (uploadHandler)="uploadXLSX($event.files, filesForm)" [auto]="true" [multiple]="false"
                      accept=".xlsx,.xls"
                      chooseLabel="Import Data"></p-fileUpload>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns" class="material-header">
        {{col?.header}}
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-rowData let-colData="columns">
    <tr [pSelectableRow]="rowData">
      <td pEditableColumn class="editable-cell name-cell">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="string" class="material-input-text" [(ngModel)]="rowData.cabinetName"
                   (ngModelChange)="editMaterial(rowData)">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.cabinetName}}
          </ng-template>
        </p-cellEditor>
      </td>
      <td pEditableColumn class="editable-cell desc-cell">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text" [(ngModel)]="rowData.complexityType"
                   (ngModelChange)="editMaterial(rowData)">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.complexityType}}
          </ng-template>
        </p-cellEditor>
      </td>
      <td pEditableColumn class="editable-cell desc-cell">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text" [(ngModel)]="rowData.complexityStyle"
                   (ngModelChange)="editMaterial(rowData)">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.complexityStyle}}
          </ng-template>
        </p-cellEditor>
      </td>
      <td pEditableColumn class="editable-cell desc-cell">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text" [(ngModel)]="rowData.complexityMultiplier"
                   (ngModelChange)="editMaterial(rowData)">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.complexityMultiplier}}
          </ng-template>
        </p-cellEditor>
      </td>
      <td>
        {{rowData.overallComplexity | number: '1.2-2'}}
      </td>
      <!--      <td pEditableColumn class="editable-cell desc-cell">-->
      <!--        <p-cellEditor>-->
      <!--          <ng-template pTemplate="input">-->
      <!--            <input pInputText type="string" class="material-input-text" [(ngModel)]="rowData.overallComplexity"-->
      <!--                   (ngModelChange)="editMaterial(rowData)">-->
      <!--          </ng-template>-->
      <!--          <ng-template pTemplate="output">-->
      <!--            {{rowData.overallComplexity}}-->
      <!--          </ng-template>-->
      <!--        </p-cellEditor>-->
      <!--      </td>-->
    </tr>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="spinner-block" *ngIf="loadings.length > 0">
      <lib-progress-spinner></lib-progress-spinner>
    </div>
  </ng-template>
</p-table>
